export default __webpack_public_path__ + "static/media/CardTitleCheck.8fc0800a.svg";